import { delayTaskParameters } from "../../../shared/consts/table";
import { IDelayQuestions } from "../../../shared/types/questions";
import { headerAuthorization } from "../../../shared/helpers/localstorage-helper";
import { BASE_URL } from '../../../shared/consts/variables';

export interface IPlanUsage {
    companyName: string;
    planName: string;
    usedThisMonth: number;
    monthlyLimit: number;
    remaining: number | 'ilimitado';
    resetsAt: string;
}

export interface IRemainingUsage {
    companyId: string;
    companyName: string;
    status: {
        active: any,
        hasAvailableLicenses: boolean
    };
    licenses: {
        isUnlimited: boolean;
        percentageUsed: any;
        remaining: number;
        total: number;
        used: number
    }
}

export interface ICreateAnswerResponse extends IDelayQuestions {
    id?: number;
    createdAt?: string;
    updatedAt?: string;
    planUsage: IPlanUsage;
}

export interface IGetAnswersResponse {
    data: IDelayQuestions[];
    total: number;
    filters: {
        companyId: string;  // ✅ Mudado de clientId
        startDate: string | null;
        endDate: string | null;
    };
    period: {
        start: string | null;
        end: string | null;
    };
}

// NOVAS INTERFACES PARA GERENCIAMENTO DE TESTES (SUPER ADMIN)
export interface IDDCurtoTestData extends IDelayQuestions {
    id: string;
    companyName: string;
}

export interface IGetAllDDCurtoAnswersResponse {
    data: IDDCurtoTestData[];
    total: number;
}

export interface IDeleteDDCurtoAnswerResponse {
    message: string;
    deletedTest: {
        id: string;
        nome: string;
        record_id: string;
        companyName: string;
        createdAt: string;
    };
}

export const fetchSearchResults = async () => {
    return delayTaskParameters;    
}

export const postSearchResults = async (resultObject: IDelayQuestions): Promise<ICreateAnswerResponse> => {
    const response = await fetch(`${BASE_URL}/dd-curto/questions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify(resultObject),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao criar resposta');
    }

    return response.json();
}

export const getSearchResults = async (query: URLSearchParams): Promise<IGetAnswersResponse> => {
    const response = await fetch(`${BASE_URL}/dd-curto/questions?${query}`, {
        headers: {
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar respostas');
    }

    return response.json();
}

export const getPlanUsage = async (id: string): Promise<IRemainingUsage> => {
    const response = await fetch(`${BASE_URL}/dd-curto/usage/${id}`, {
        headers: {
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar uso do plano');
    }

    return response.json();
}

export const getAllDDCurtoAnswer = async (): Promise<IGetAllDDCurtoAnswersResponse> => {
    const response = await fetch(`${BASE_URL}/dd-curto/all`, {
        headers: {
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar todos os testes');
    }

    return response.json();
}

export const deleteDDCurtoAnswer = async (testId: string): Promise<IDeleteDDCurtoAnswerResponse> => {
    const response = await fetch(`${BASE_URL}/dd-curto/test/${testId}`, {
        method: 'DELETE',
        headers: {
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao excluir teste');
    }

    return response.json();
}
